export default __webpack_public_path__ + "static/media/four_tou2.12824b95.png";